module.exports = __webpack_public_path__ + "img/1.6c409649.jpg";